const DeliveriesServiceFactory = ({ HTTPDeviations }) => {
    return {
        getAlertsSummary: (farmId) => {
            return HTTPDeviations.get(`farm/${farmId}/dashboard/feeding/deliveries/alerts/summary`).then((res) => res.data);
        },
        getAlerts: (farmId) => {
            return HTTPDeviations.get(`farm/${farmId}/dashboard/feeding/deliveries/alerts`).then((res) => res.data);
        },
        getDeviations: (farmId, groupId) => {
            return HTTPDeviations.get(`farm/${farmId}/dashboard/feeding/deliveries/deviations/${groupId}`).then((res) => res.data);
        },
        deleteAlerts: (farmId, ids) => {
            return HTTPDeviations.post(`farm/${farmId}/dashboard/feeding/deliveries/alerts/clear?groupIds=${ids.join(',')}`);
        },
        deleteItemAlerts: (farmId, id) => {
            return HTTPDeviations.post(`farm/${farmId}/dashboard/feeding/deliveries/alerts/${id}/clear`);
        },
    };
};
export default DeliveriesServiceFactory;
//# sourceMappingURL=deliveries.api.js.map